/**
 * Created by Administrador on 17/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('itemService', itemService)

    itemService.$inject = ['$http', 'CONFIG', 'messageService'];

    function itemService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CARGO_CONTROL + '/' + CONFIG.API + '/items';
        var service = {
            getItems: getItems,
            getItem: getItem,
            saveItem: saveItem,
            updateItem: updateItem,
            deleteItem: deleteItem
        }

        return service;

        function getItems(page, size){
            return $http.get(urlBase + '?page=' + page + '&size=' + size + '&detailed=true')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getItem(id, detailed){
            return $http.get(urlBase + "/" + id +"?detailed="+detailed)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('items')
                });
        }

        function saveItem(item){
            return $http.post(urlBase, item)
                .then(function(response){
                    messageService.register('items');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('items')
                });
        }

        function updateItem(itemId, item){
            return $http.put(urlBase + "/" + itemId, item)
                .then(function(response){
                    messageService.registerUpdate('items')
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('items')
                });
        }

        function deleteItem(itemId){
            return $http.delete(urlBase + "/" + itemId)
                .then(function(response){
                    messageService.registerDelete('items');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('items');
                });
        }
    }
})();
